import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import StatusCards from "../../components/card/StatusCards";
import MerchantList from "../../components/list/MerchantList";
import Mrlist from "../../components/list/Mrlist";
import Businesspartner from "../../components/list/Businesspartner";
import StatusCardscm from "../../components/card/StatusCardscm";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import { useDispatch } from "react-redux";

function MyVerticallyCenteredModal(props) {
  return (
    <Modal
      {...props}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">
         🔄 Application Under Review
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <h4>Application In Progress</h4>
        <p>
          ⏳ Hang Tight! We’ve received your application and it’s being
          processed.Thank you for your patience.
        </p>
      </Modal.Body>
      <Modal.Footer>
        <Button onClick={props.onHide}>Logout</Button>
      </Modal.Footer>
    </Modal>
  );
}

const Dashbord = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [userData, setUserData] = useState({});
  const [modalShow, setModalShow] = useState(false);
  const roleType = localStorage.getItem("role_type"); // Retrieve roleType from localStorage if not in state
  console.log("Received roleType from login route storage --->", roleType);

  const onLogoutHandle = ()=>{
    localStorage.clear()
    dispatch({ type: 'auth/logout' });
    navigate('/loginscreen')
  }

  useEffect(() => {
    const data = localStorage.getItem("user");
    if (data) {
      const parsedData = JSON.parse(data);
      setUserData(parsedData);

      console.log(parsedData.member_active);

      setModalShow(
        parsedData.member_active === 2 || parsedData.member_active === 3
      );
    }
  }, []);

  return (
    <div>
      {/* Show Mrlist for both Admin and Company */}
      {(roleType === null || roleType === "2") && (
        <>
          {" "}
          <StatusCardscm /> <Mrlist />{" "}
        </>
      )}

      {/* Show both Mrlist and MerchantList for Admin */}
      {roleType === "admin" && (
        <>
          <StatusCards />
          <MerchantList />
          <div style={{ height: "2rem" }}></div>
          <Businesspartner />
        </>
      )}
      {/* userData.member_active==2 && */}

      <MyVerticallyCenteredModal
        show={modalShow}
        onHide={() =>{
          onLogoutHandle()
          setModalShow(false)
        } }
      />
    </div>
  );
};

export default Dashbord;
